import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCustomerServiceFeaturesRoute: InvariantJiraRoute = {
	name: 'project-settings-customer-service-features',
	path: '/jira/servicedesk/projects/:projectKey/settings/features',
	exact: true,
};
